import axios from 'axios';
import config from '../config/config';
import {
    SUPPORTER_DETAILS_REQUEST_SUPPORTER,
    SUPPORTER_DETAILS_RECEIVE_SUPPORTER,
    SUPPORTER_DETAILS_CHANGE_VALUE,
    SUPPORTER_DETAILS_TOOGLE_BOOLEAN_VALUE,
    SUPPORTER_DETAILS_SEND_SAVE,
    SUPPORTER_DETAILS_RECEIVE_SAVE,
    SUPPORTER_DETAILS_RECEIVE_SAVE_ERROR,
    SUPPORTER_DETAILS_EDIT
} from '../config/actions';

export function getSupporter(id) {
    return dispatch => {
        dispatch({
            type: SUPPORTER_DETAILS_REQUEST_SUPPORTER
        });
        axios(config.server.endpoint + 'backend/supporter/' + id, {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                dispatch({
                    type: SUPPORTER_DETAILS_RECEIVE_SUPPORTER,
                    data: response.data
                });
            }
        })
    }
}

export function changeValue(name, value) {
    return {
        type: SUPPORTER_DETAILS_CHANGE_VALUE,
        name,
        value
    }
}

export function toggleBooleanValue(name) {
    return {
        type: SUPPORTER_DETAILS_TOOGLE_BOOLEAN_VALUE,
        name
    }
}

export function editSupporterDetails() {
    return {
        type: SUPPORTER_DETAILS_EDIT
    }
}

export function saveSupporterDetails(data) {
    return dispatch => {
        dispatch({
            type: SUPPORTER_DETAILS_SEND_SAVE
        });
        axios(config.server.endpoint + 'backend/supporter/' + data.id, {
            method: 'put',
            data: {
                lastname: data.lastname,
                firstname: data.firstname,
                nickname: data.nickname || '',
                pronoun: data.pronoun || '',
                pronounOthers: data.pronounOthers || '',
                email: data.email,
                phone: data.phone,
                zipcode: data.zipcode,
                city: data.city,
                country: data.country,
                birthday: data.birthday,
                handycap: data.handycap,
                setNewPassword: data.setNewPassword,
                newPassword: data.newPassword
            }
        }).then((response) => {
            if (response.status === 200) {
                if (response.data.success === true) {
                    dispatch({
                        type: SUPPORTER_DETAILS_RECEIVE_SAVE,
                        data: response.data
                    });
                } else {
                    dispatch({
                        type: SUPPORTER_DETAILS_RECEIVE_SAVE_ERROR,
                        data: response.data
                    });
                }
            }
        });
    }
}